import PropTypes from 'prop-types'
import React from 'react'
import config from 'SRC/config/config.yaml'

export const Listing = ({packages, userType}) => {
  const text = config.registrationForm.package.listing
  return <tr>
    <td>{text} <strong>{userType}</strong></td>
    {
      packages.map(item => <td key={item.id}>{<i className={`ico-${item.listing ? `ima` : `nema`} ico`} />}</td>)
    }
  </tr>
}

Listing.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    listing: PropTypes.bool
  })).isRequired,
  userType: PropTypes.string.isRequired
}

Listing.defaultProps = {
  packages: []
}
